import { useEffect } from 'react';
import { useRuntimeConfig } from 'vl-common/src/hooks/Runtime';

export const useAdobeClientId = () => {
  const { ADOBE_SDK_KEY, ADOBE_SDK_KEY_LOCALHOST } = useRuntimeConfig();
  const isLocalhost = window.location.hostname === 'localhost';
  const clientId = isLocalhost ? ADOBE_SDK_KEY_LOCALHOST : ADOBE_SDK_KEY;

  useEffect(() => {
    if (isLocalhost && !ADOBE_SDK_KEY_LOCALHOST) {
      console.warn('ADOBE_SDK_KEY_LOCALHOST is missing in runtime config, Adobe PDF viewer will not load on localhost');
    }
  }, [isLocalhost, ADOBE_SDK_KEY_LOCALHOST]);

  return clientId;
};
